import { render } from "./Purchased.vue?vue&type=template&id=426e90e2&scoped=true"
import script from "./Purchased.vue?vue&type=script&lang=js"
export * from "./Purchased.vue?vue&type=script&lang=js"

import "./Purchased.vue?vue&type=style&index=0&id=426e90e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-426e90e2"

export default script